import { NgIf, NgFor, AsyncPipe, LowerCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDivider } from '@angular/material/divider';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { RootState } from '@next/core-lib/app';
import { AgrNotificationEmptyModule } from '@next/core-lib/components';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';

import { UserPreferenceSetting } from '../../models/preferences.model';
import * as PreferenceActions from '../../store/preferences.actions';
import * as PreferenceSelectors from '../../store/preferences.selectors';

@Component({
  selector: 'app-preferences-overview',
  templateUrl: './preferences-overview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./preferences-overview.component.scss'],
  imports: [MatDivider, NgIf, NgFor, MatSlideToggle, FormsModule, AgrNotificationEmptyModule, AsyncPipe, LowerCasePipe, AgrI18nSharedModule],
})
export class PreferencesOverviewComponent implements OnDestroy {
  public preferenceGroups$ = this.store.select(PreferenceSelectors.getPreferenceGroups);

  constructor(private readonly store: Store<RootState>) {}

  ngOnDestroy(): void {
    this.store.dispatch(PreferenceActions.clearPreferenceGroupsRequest());
  }

  updateUserSetting(groupKey: string, subGroupKey: string, method: string, enabled: boolean) {
    const userPreferenceSetting: UserPreferenceSetting = {
      groupKey,
      subGroupKey,
      method,
      enabled,
    };

    this.store.dispatch(PreferenceActions.patchPreferenceRequest({ preference: userPreferenceSetting }));
  }
}
